module.exports = __webpack_public_path__ + "static/media/logoPacto.ef40cadc.svg";